/**
 * Reducer for indirect cost
 */
import Types from "../../actions/Types";

export const indirect_cost_type_list =(state = {costs:[],isLoaded:false},action)=>{
    switch (action.type) {
        case Types.GET_ALL_INDIRECT_COSTS:
            return {...state,costs:action.payload,isLoaded:true};
        case Types.IS_INDIRECT_COST_LOADING :
            return {...state,isLoaded: action.payload};
        default:
            return state;
    }
}

export const indirect_cost_error = (state = false , action ) => {
    switch(action.type){
        case Types.IS_GET_INDIRECT_COST_ERROR :
            return action.payload ;
        default :
            return state ;
    }
}

export const indirect_cost_data_error = (state  = { visiable : false , errors : [] }  , action) => {
    switch(action.type){
        case Types.IS_GET_INDIRECT_COST_DATA_ERROR :
            return {...state , visiable : action.payload , errors : action.errors } ;
        default :
            return state ;
    }
}





